module.exports = __webpack_public_path__ + "static/8d-b934a80f662c1d4703823ba574396022.jpg";